import script from "./xiaolijiaoshikebiao.vue?vue&type=script&setup=true&lang=js"
export * from "./xiaolijiaoshikebiao.vue?vue&type=script&setup=true&lang=js"

import "./xiaolijiaoshikebiao.vue?vue&type=style&index=0&id=54ffdb64&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54ffdb64"]])

export default __exports__